<template>
  <div class="modal">
    <div class="empty" @click="$emit('close')"></div>
    <div class="box">
      <div class="title">{{ titlec }}</div>
      <div class="close" @click="$emit('close')"><i class="fa-solid fa-xmark"></i></div>

      <div class="cats">
        <button v-for="(v, i) in cats" :key="i" @click="getNames(v.id)">{{ v.title }}</button>
      </div>

      <div class="content">
        <TransitionGroup name="list" :duration="500">
          <div class="vote active" v-for="(n,i) in names" :key="i" :style="{transitionDelay: i/2+'s'}"
               @click="setVote(n.id, i)">
            <div class="avatar"
                 :style="{backgroundImage: `url('${avatarUrl(n, { action: 'std,crr=', direction: 0, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
            <span>{{ n }}</span>
          </div>
        </TransitionGroup>
        <div class="text" v-show="names.length === 0">
          <p>Selecione uma categoria para voto!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getVoteCats, getVoteNames, vote as apiVote, avatarUrl } from '@/services/api.js'
import { ref } from 'vue'
import { useStore } from '@/stores/index.js'

const store = useStore()

const props = defineProps({
  titlec: {
    type: String,
    default: () => ''
  },
  id: Number
})

const cats = ref([])
const names = ref([])
const cat_id = ref(0)

async function getCats() {
  cats.value = await getVoteCats(props.id)
}

async function getNames(i) {
  cat_id.value = i
  names.value  = await getVoteNames(i)
}

async function setVote(_id, name) {
  const data = await apiVote(cat_id.value, name)
  store.Alert(data.text)
}

getCats()

</script>

<style scoped>

.modal .content {
  height: auto;
  user-select: none;
}

.modal .close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}

.modal .title {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 600;
  line-height: 50px;
  padding-left: 20px;
  background-color: var(--color1);
  border-radius: 8px 8px 0 0;
  color: #fff;
}

.modal .cats {
  position: absolute;
  width: 200px;
  height: auto;
  left: -50%;
  background-color: #fff;
  border-radius: 10px 0 0 10px;
}

.modal .cats button {
  width: 100%;
  height: 50px;
  font-size: 14px;
  font-weight: 600;
}

/*noinspection ALL*/
.modal .content .vote {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin-top: 4px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background-color: var(--color2);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  transition: all 1s;
}

.modal .content .vote .avatar {
  width: 56px;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center -40px;
  margin-right: 20px;
}

.modal .content .text p {
  text-align: center;
  width: 100%;
  height: 80px;
  line-height: 80px;
}
</style>
